import type {ResponseBody} from '@gongxigames/framework/integrations/rubyplay/types';

export interface IModHandler {
    getInitSessionRequestPayload(clientVersion?: string): Record<string, any>;
    handleInitSessionResponse(body: ResponseBody): void;
    getActionRequestPayload(): Record<string, any>;
    handleActionResponse(body: ResponseBody): void;
    getOddsAcceptancePayload(): Record<string, any>;
    extendUrl(url: string): string;
}